import ApiClient from '@/helpers/api/api.helpers';
class UserDetails extends ApiClient {
  constructor() {
    super('iam');
  }
}

export default new UserDetails();
